import React from "react";
import { Container, Card, Row, Col, Badge, ListGroup } from "react-bootstrap";

export const TicketPreview = ({ ticket }) => {
  const formatDate = (dateStr) =>
    new Date(dateStr).toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });

  const StatusBadge = ({ status }) => {
    const variants = {
      onsale: "success",
      paused: "danger",
      disable: "secondary",
    };
    return (
      // <Badge bg={variants[status] || "secondary"} className="text-uppercase">
      //   {status.charAt(0).toUpperCase() + status.slice(1)}
      // </Badge>
      <></>
    );
  };

  const renderAddons = (addons, isGuest = false) => (
    <div className="mb-3">
      {addons.map((addon, index) => (
        <Card key={index} className="mb-3 shadow-sm">
          <Card.Body>
            <div className="d-flex justify-content-between align-items-start">
              <div>
                <Card.Title as="h6" className="mb-1">{addon.add_on_name}</Card.Title>
                <Card.Text className="text-muted small">{addon.description}</Card.Text>
              </div>
              {addon.image && (
                <img
                  src={addon.image}
                  alt={addon.add_on_name}
                  style={{ width: "64px", height: "64px", objectFit: "cover" }}
                  className="rounded"
                />
              )}
            </div>
            <ListGroup variant="flush" className="mt-2">
              {addon.variant_options.map((variant, idx) => (
                <ListGroup.Item key={idx} className="py-1">
                  {variant.name} - {variant.quantity} pcs @ {variant.price} {addon.currency}
                </ListGroup.Item>
              ))}
            </ListGroup>
            <div className="mt-3 d-flex justify-content-between align-items-center">
              <div>
                <span className="fw-medium">Status: </span>
                <StatusBadge status={addon.addon_status} />
              </div>
              <Badge bg={addon.isMandatory ? "primary" : "secondary"} className="small">
                {addon.isMandatory ? "Mandatory" : "Optional"}
              </Badge>
            </div>
            <div className="mt-2 small">
              <span>Tax: {addon.tax_type}</span>
              {addon.tax_options?.length > 0 && (
                <span>
                  {" - "}
                  {addon.tax_options[0].tax_name} ({addon.tax_options[0].tax_percentage}%)
                </span>
              )}
            </div>
          </Card.Body>
        </Card>
      ))}
    </div>
  );

  return (
    <Container className="my-5">
      <Card className="shadow">
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <Card.Title as="h3" className="mb-0">
              {ticket.ticket_name}
              {ticket.show_promational_label === "yes" && (
                <Badge bg="warning" text="dark" className="ms-2">
                  {ticket.promational_label_text || "Special Offer"}
                </Badge>
              )}
            </Card.Title>
            <StatusBadge status={ticket.ticket_status} />
          </div>
          <Card.Text className="text-black mb-4">{ticket.description}</Card.Text>

          <Row className="mb-4">
            <Col md={6}>
              <Card className="shadow-sm">
                <Card.Body>
                  <Card.Title as="h5" className="mb-3">Ticket Details</Card.Title>
                  <dl className="mb-0">
                    <dt className="fw-medium">Price:</dt>
                    <dd className="text-black">
                      {ticket.pricing_option === "fixed"
                        ? `${ticket.price} ${ticket.currency}`
                        : "Variable Pricing"}
                    </dd>
                    <dt className="fw-medium mt-2">Quantity:</dt>
                    <dd className="text-black">{ticket.quantity}</dd>
                    <dt className="fw-medium mt-2">Min/Max Order:</dt>
                    <dd className="text-black">
                      {ticket.ticket_min_order} / {ticket.ticket_max_order}
                    </dd>
                    <dt className="fw-medium mt-2">Private:</dt>
                    <dd className="text-black">{ticket.private_ticket === "yes" ? "Yes" : "No"}</dd>
                    {ticket.qrcode === "yes" && (
                      <>
                        <dt className="fw-medium mt-2">QR Code:</dt>
                        <dd className="text-black">Enabled</dd>
                      </>
                    )}
                  </dl>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card className="shadow-sm">
                <Card.Body>
                  <Card.Title as="h5" className="mb-3">Additional Details</Card.Title>
                  <dl className="mb-0">
                    <dt className="fw-medium">Ticket Type:</dt>
                    <dd className="text-black">{ticket.ticket_type}</dd>
                    <dt className="fw-medium mt-2">Group:</dt>
                    <dd className="text-black">{ticket.ticket_group}</dd>
                    <dt className="fw-medium mt-2">Sale Start:</dt>
                    <dd className="text-black">{formatDate(ticket.start_sale)}</dd>
                    <dt className="fw-medium mt-2">Sale End:</dt>
                    <dd className="text-black">{formatDate(ticket.end_sale)}</dd>
                    <dt className="fw-medium mt-2">Tax:</dt>
                    <dd className="text-black">
                      {ticket.tax_type} – {ticket.tax_registration_no}
                      {ticket.tax_options?.length > 0 && (
                        <ListGroup variant="flush" className="mt-1">
                          {ticket.tax_options.map((tax, idx) => (
                            <ListGroup.Item key={idx} className="py-1 text-black">
                              {tax.tax_name}: {tax.tax_percentage}%
                            </ListGroup.Item>
                          ))}
                        </ListGroup>
                      )}
                    </dd>
                  </dl>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {ticket.pricing_option === "variable" && ticket.variable_prices?.length > 0 && (
            <div className="mb-4">
              <h4 className="mb-3">Variable Pricing</h4>
              <Card className="shadow-sm">
                <ListGroup variant="flush">
                  {ticket.variable_prices.map((vp, i) => (
                    <ListGroup.Item key={i} className="text-black">
                      {vp.price} {ticket.currency} - Valid until {formatDate(vp.valid_till)}
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </Card>
            </div>
          )}

          {ticket.addons?.length > 0 && (
            <div className="mb-4">
              <h4 className="mb-3">Ticket Add-ons</h4>
              {renderAddons(ticket.addons)}
            </div>
          )}

          {ticket.guest_details && (
            <div className="mt-5">
              <h3 className="text-success mb-4">Guest Ticket</h3>
              <Card className="shadow-sm border-success">
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <Card.Title as="h4" className="mb-0">
                      {ticket.guest_details.ticket_name}
                    </Card.Title>
                    <StatusBadge status={ticket.guest_details.ticket_status} />
                  </div>
                  <Card.Text className="text-black mb-4">{ticket.guest_details.description}</Card.Text>
                  <Row>
                    <Col md={6}>
                      <Card className="shadow-sm">
                        <Card.Body>
                          <Card.Title as="h5" className="mb-3">Ticket Details</Card.Title>
                          <dl className="mb-0">
                            <dt className="fw-medium">Price:</dt>
                            <dd className="text-black">
                              {ticket.guest_details.price ? (
                                `${ticket.guest_details.price} ${ticket.guest_details.currency}`
                              ) : (
                                <Badge bg="success">FREE</Badge>
                              )}
                            </dd>
                            <dt className="fw-medium mt-2">Quantity:</dt>
                            <dd className="text-black">{ticket.guest_details.quantity}</dd>
                            <dt className="fw-medium mt-2">Min/Max Order:</dt>
                            <dd className="text-black">
                              {ticket.guest_details.ticket_min_order} / {ticket.guest_details.ticket_max_order}
                            </dd>
                            <dt className="fw-medium mt-2">Private:</dt>
                            <dd className="text-black">
                              {ticket.guest_details.private_ticket === "yes" ? "Yes" : "No"}
                            </dd>
                          </dl>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col md={6}>
                      <Card className="shadow-sm">
                        <Card.Body>
                          <Card.Title as="h5" className="mb-3">Additional Details</Card.Title>
                          <dl className="mb-0">
                            <dt className="fw-medium">Ticket Type:</dt>
                            <dd className="text-black">{ticket.guest_details.ticket_type}</dd>
                            <dt className="fw-medium mt-2">Sale Start:</dt>
                            <dd className="text-black">{formatDate(ticket.guest_details.start_sale)}</dd>
                            <dt className="fw-medium mt-2">Sale End:</dt>
                            <dd className="text-black">{formatDate(ticket.guest_details.end_sale)}</dd>
                            <dt className="fw-medium mt-2">Tax:</dt>
                            <dd className="text-black">
                              {ticket.guest_details.tax_type} – {ticket.guest_details.tax_registration_no}
                            </dd>
                          </dl>
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                  {ticket.guest_details.addons?.length > 0 && (
                    <div className="mt-4">
                      <h4 className="mb-3">Guest Add-ons</h4>
                      {renderAddons(ticket.guest_details.addons, true)}
                    </div>
                  )}
                </Card.Body>
              </Card>
            </div>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};